import { api } from "api/api";
import { AxiosError } from "axios";

class ReportService {
    getNomeReport(nomeAcao: string) {
        return new Promise<string>((resolve, reject): void => {
            api
                .get(`/jasper/nomeArquivo/${nomeAcao}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getReport(nomeAcao: string){
        return new Promise<Blob>((resolve, reject): void => {
            api
                .get(`/jasper/${nomeAcao}`, {responseType: 'arraybuffer'})
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    gravarReport(nomeAcao: string, report: File){
        return new Promise<void>((resolve, reject): void => {
            const formData = new FormData();
            formData.append('report', report as Blob);
            formData.append('nomeAcao', nomeAcao);
            api
                .postForm(`/jasper`, formData)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}

export default ReportService;
